module.exports = __webpack_public_path__ + "img/img1_gr.ea7d9f2e.png";